export default __webpack_public_path__ + "static/media/bo.4f00c110.svg";